import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AgentSidebar from "./AgentSidebar";
import AgentHeader from "./agentdashboard/AgentHeader";
import AgentFooter from "./agentdashboard/AgentFooter";
import { getAgentRouteInfo } from "./agentdashboard/GetAgentRouteInfo";

const AgentLayout = () => {
  const location = useLocation();
  const { pageTitle, breadcrumbs } = getAgentRouteInfo(location.pathname);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="vendor-dashboard-layout d-flex ">

      {/* SIDEBAR */}
      <div className={`vendor-sidebar ${sidebarOpen ? "open" : ""}`}>
        <AgentSidebar closeSidebar={() => setSidebarOpen(false)} />
      </div>

      {/* OVERLAY (Mobile) */}
      {sidebarOpen && (
        <div
          className="vendor-sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* RIGHT SIDE */}
      <div className="flex-grow-1 d-flex flex-column bg-light">

        {/* HEADER */}
        <AgentHeader
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          onMenuClick={() => setSidebarOpen(true)}
        />

        {/* CONTENT */}
        <div className="vendor-content-area p-4 pb-5">
          <Outlet />
        </div>

        {/* FOOTER */}
        <AgentFooter />

      </div>
    </div>
  );
};

export default AgentLayout;
